import LocationMessage from './LocationMessage';

export default LocationMessage;
